export default __webpack_public_path__ + "static/media/14461.finance-society.photo.c0c327ff.jpg";